import React, { useState } from 'react'
import { MONOPOLIO_PROPERTY_TYPES } from '@/utils/constants'
import Checkbox from '@dd3tech/wiggui/Checkbox'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Button from '@dd3tech/wiggui/Button'

interface IProps {
  onChangePropertyType: (value: { property_type: string[] }) => void
  propertyTypes: string[]
  typesToShow?: number
}
export const PropertyTypes = ({
  onChangePropertyType,
  typesToShow = 4,
  propertyTypes
}: IProps) => {
  const [showAll, setShowAll] = useState(false)

  const onCheckboxChange = (value: boolean, name?: string) => {
    if (!name) {
      return
    }
    const newPropertyTypes = propertyTypes ? [...propertyTypes] : []
    const index = newPropertyTypes.indexOf(name)
    const isChecked = index !== -1
    if (value && !isChecked) {
      newPropertyTypes.push(name)
      onChangePropertyType({ property_type: newPropertyTypes })
      return
    }
    if (isChecked) {
      newPropertyTypes.splice(index, 1)
      onChangePropertyType({ property_type: newPropertyTypes })
    }
  }
  const checkboxOptions = showAll
    ? [...MONOPOLIO_PROPERTY_TYPES]
    : [...MONOPOLIO_PROPERTY_TYPES].slice(0, typesToShow)
  return (
    <>
      {checkboxOptions.map(({ value, label, icon }) => {
        const isChecked = propertyTypes.includes(value)
        return (
          <Checkbox
            key={label}
            name={value}
            id={value}
            type="checkbox"
            as="button"
            gap="gap-3"
            items="start"
            justify="between"
            containerClassName={`flex-row-reverse w-full rounded-xl p-4 outline-none [&>svg]:hidden ${
              isChecked
                ? '!border-2 border-primary !bg-button-secondary'
                : 'border border-surface-strokes bg-white hover:bg-button-disabled hover:border hover:border-primary'
            }`}
            isChecked={isChecked}
            onChange={onCheckboxChange}
            label={
              <div className="flex gap-1">
                <GoogleIcon
                  className={`text-2xl font-bold leading-6 ${
                    isChecked ? 'text-notif-blue' : 'text-primary'
                  }`}
                  name={icon}
                />
                {label && (
                  <p
                    className={`text-[15px] text-primary ${
                      isChecked ? ' font-bold' : ''
                    }`}
                  >
                    {label}
                  </p>
                )}
                {isChecked && (
                  <GoogleIcon
                    className="absolute right-[17px] top-3 font-extrabold text-lg text-white"
                    name="check"
                  />
                )}
              </div>
            }
            inputClassName="!min-w-[20px] !min-h-[20px] !max-h-[20px] !w-5 h-5 !p-2"
          />
        )
      })}
      <Button
        className={showAll ? 'hidden' : 'block'}
        type="button"
        size="small"
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          setShowAll((prev) => !prev)
        }}
        variant="terciary"
      >
        Ver todas
      </Button>
    </>
  )
}
